import { styled } from 'styled-components';

export const List = styled.ul`
  column-gap: var(--spacing-small);
  display: grid;
  font-weight: var(--font-semibold);
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: var(--spacing-small);
`;
